module.exports = __webpack_public_path__ + "static/media/protection.a2b6dd41.png";